import superagent from 'superagent/lib/client'
import globalSuperAgent from 'superagent-use'

export const agent = globalSuperAgent(superagent)
